import { render } from "./TasteView.vue?vue&type=template&id=d073da82&scoped=true"
import script from "./TasteView.vue?vue&type=script&lang=js"
export * from "./TasteView.vue?vue&type=script&lang=js"

import "./TasteView.vue?vue&type=style&index=0&id=d073da82&scoped=true&lang=css"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d073da82"]])

export default __exports__